import { autoinject } from "aurelia-framework";
import { HttpClient } from "aurelia-fetch-client";

@autoinject
export class FileService {
	constructor(private http: HttpClient) {
		http.configure(config => {
			config
				.withBaseUrl('/api/')
				.withDefaults({
					credentials: 'same-origin'
				});
		});
	}
	
	public async upload<TResponse>(url: string, content: Blob | File, method: string = 'post'): Promise<TResponse> {
		const formData = new FormData();
		formData.append("file", content);
		
		const result = await this.http.fetch(url, {
			method,
			body: formData
		});
		
		const response: TResponse = await result.json();
		
		return response;
	}
}
